import { Loading } from "@dgs/core";
import { useQuery } from "@tanstack/react-query";
import { FC, useMemo } from "react";
import { useParams } from "react-router";
import { ClippingList } from "../../clippings/ClippingList";
import { entityClippingsService } from "../../shared/api/clippingsService";
import { contactService } from "../../shared/api/contactService";

export const ContactClippingList: FC<{ readonly?: boolean }> = ({ readonly }) => {
	const { id = "" } = useParams<"id">();
	const service = useMemo(() => entityClippingsService("contacts", id), [id]);

	const { data: contact, isLoading: isContactLoading } = useQuery({
		queryKey: contactService.showKey(id),
		queryFn: () => contactService.show(id).then((res) => res.data.data),
	});

	if (isContactLoading) {
		return <Loading />;
	}

	return <ClippingList contact={contact} service={service} readonly={readonly} />;
};
